import React from "react";
import "./Sidebar.scss";
import { IoHomeOutline } from "react-icons/io5";
import { HiOutlineBuildingOffice2 } from "react-icons/hi2";
import { IoPeopleOutline } from "react-icons/io5";
import { Link, useLocation } from "react-router-dom";
import { BiTask } from "react-icons/bi";
import { AiOutlineFundProjectionScreen } from "react-icons/ai";
import { GoTasklist } from "react-icons/go";
import { useStateValue } from "../../StateProvider";
import { isAdmin } from "../../utils/adminAccess";
import { IoMdNotificationsOutline } from "react-icons/io";
import { TbReportAnalytics } from "react-icons/tb";
import { RxActivityLog } from "react-icons/rx";
import { Tooltip } from "react-tooltip";

const Sidebar = ({ toggle,isToggled }) => {
  const { pathname } = useLocation();
  const [{ userInfo }, dispatch] = useStateValue();

  return (
    <div className="app-menu">
      {/* Sidebar */}
      <div className="navbar-vertical navbar nav-dashboard">
        <div className="h-100" data-simplebar="">
          {/* Brand logo */}
          <div className="logo ">T</div>
          {/* Navbar nav */}
          <ul className="navbar-nav flex-column" id="sideNavbar">
            {/* Nav item */}

            <li className="nav-item" data-tooltip-content="Dashboard">
              <Link
                to="/"
                className={`nav-link has-arrow ${pathname === "/" ? "active" : ""
                  } `}
                onClick={() => {if(!isToggled || window.innerWidth <768){ toggle()}}}
              >
                <IoHomeOutline size={16} />
                <span>

                  Dashboard
                </span>
              </Link>
            </li>
            {/* Nav item */}
            <li className="nav-item" data-tooltip-content="Tasks">
              <Link
                to="/task"
                className={`nav-link has-arrow ${pathname === "/task" ? "active" : ""
                  } `}
                onClick={() => {if(!isToggled || window.innerWidth <768){ toggle()}}}
              >
                <GoTasklist size={16} />
                <span>

                  Tasks
                </span>
              </Link>
            </li>
            <li className="nav-item" data-tooltip-content="Project">
              <Link
                to="/project"
                className={`nav-link has-arrow ${pathname === "/project" ? "active" : ""
                  } `}
                onClick={() => {if(!isToggled || window.innerWidth <768){ toggle()}}}
              >
                <AiOutlineFundProjectionScreen size={16} />
                <span>

                  Project
                </span>
              </Link>
            </li>
            <li className="nav-item" data-tooltip-content="Notification">
              <Link
                to="/notification"
                className={`nav-link has-arrow ${pathname === "/notification" ? "active" : ""
                  } `}
                onClick={() => {if(!isToggled || window.innerWidth <768){ toggle()}}}
              >
                <IoMdNotificationsOutline size={16} />
                <span>

                  Notification
                </span>
              </Link>
            </li>
            <li className="nav-item" data-tooltip-content="Report">
              <Link
                to="/report"
                className={`nav-link has-arrow ${pathname === "/report" ? "active" : ""
                  } `}
                onClick={() => {if(!isToggled || window.innerWidth <768){ toggle()}}}
              >
                <TbReportAnalytics size={16} />
                <span>

                  Report
                </span>
              </Link>
            </li>
            {userInfo.user_type === "SysAdm" &&

              <li className="nav-item"
                 data-tooltip-content="User Activity"
              >
                <Link
                  to="/user-activity"
                  className={`nav-link has-arrow ${pathname === "/user-activity " ? "active" : ""
                    } `}
                  onClick={() => {if(!isToggled || window.innerWidth <768){ toggle()}}}
                >
                  <RxActivityLog size={16} />
                  <span>

                    User Activity
                  </span>
                </Link>
              </li>
            }
            {/* Nav item */}
            {isAdmin(userInfo) && (
              <li className="nav-item">
                <div className="navbar-heading">CONFIGURATION</div>
              </li>
            )}
            {/* Nav item */}
            {isAdmin(userInfo) && (
              <li className="nav-item" data-tooltip-content="Company">
                <Link
                  to="/company-info"
                  className={`nav-link has-arrow ${pathname === "/company-info" ? "active" : ""
                    } `}
                  onClick={() => {if(!isToggled || window.innerWidth <768){ toggle()}}}
                >
                  <HiOutlineBuildingOffice2 size={16} />
                  <span>

                    Company
                  </span>
                </Link>
              </li>
            )}

            {/* Nav item */}
            {isAdmin(userInfo) && (
              <li className="nav-item" data-tooltip-content="Staff">
                <Link
                  to="/staff"
                  className={`nav-link has-arrow ${pathname === "/staff" ? "active" : ""
                    } `}
                  onClick={() => {if(!isToggled || window.innerWidth <768){ toggle()}}}
                >
                  <IoPeopleOutline size={16} />
                  <span>

                    Staff
                  </span>
                </Link>
              </li>
            )}
            {/* Nav item */}
            {isAdmin(userInfo) && (
              <li className="nav-item" data-tooltip-content="Task Template">
                <Link
                  to="/task-template"
                  className={`nav-link has-arrow ${pathname === "/task-template" ? "active" : ""
                    } `}
                  onClick={() => {if(!isToggled || window.innerWidth <768){ toggle()}}}
                >
                  <BiTask size={16} />
                  <span>

                    Task Template
                  </span>
                </Link>
              </li>
            )}
            {/* Nav item */}
            {isAdmin(userInfo) && (
              <li className="nav-item" data-tooltip-content="Project Template">
                <Link
                  to="/project-template"
                  className={`nav-link has-arrow ${pathname === "/project-template" ? "active" : ""
                    } `}
                  // onClick={() => {if(!isToggled || window.innerWidth <768){ toggle()}}}
                  onClick={() => {if(!isToggled || window.innerWidth <768){ toggle()}}}
                >
                  <AiOutlineFundProjectionScreen size={16} />
                  <span>

                    Project Template
                  </span>
                </Link>
              </li>
            )}
          </ul>
        </div>
      </div>
      <Tooltip
      className={`${!isToggled?"d-none":""}`}
        anchorSelect=".nav-item"
        style={{ zIndex:"20",background:"#624bff" ,color:"white"}}
        place={'right'}
      />
    </div>
  );
};

export default Sidebar;
